import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Context from '../../../../store/context';
import useGet from '../../../../services/hooks/http/useGet';
import apiMethods from '../../../../apis';
import utils from '../../../../services/utils';
import FieldBold from '../../../Fields/FieldBold/FieldBold';
import CardCollaboratorResume from '../../../Cards/CardCollaboratorResume/CardCollaboratorResume';

import classes from './DetailsCollaborators.module.scss';

const DetailsCollaborators = ({ collaborators, totalValueCollaborators, payoutId, backButton, view, methodForPay }) => {
  const { businessId } = useSelector(state => state.userData);

  const {
    modal: { showError }
  } = useContext(Context);

  const [fetchGetState, setFetchGetState] = useState({ collaboratorId: null, fetch: false });

  const {
    isSuccess: getPayedVoucherSuccess,
    data: getPayedVoucher,
    isError: getPayedVoucherError,
    errorMessage
  } = useGet(apiMethods.getCollaboratorPayoutVoucher, [businessId, payoutId, fetchGetState.collaboratorId], fetchGetState.fetch);

  const downloadHandler = collaboratorId => {
    setFetchGetState({ collaboratorId, fetch: true });
  };

  useEffect(() => {
    if (getPayedVoucherSuccess) {
      utils.downloadFileByUrl(getPayedVoucher);
      setFetchGetState(fetch => ({ ...fetch, fetch: false }));
    } else if (getPayedVoucherError) {
      showError({ title: 'Descargar comprobante', description: errorMessage });
    }
  }, [errorMessage, getPayedVoucher, getPayedVoucherError, getPayedVoucherSuccess, showError]);

  return (
    <div className={classes.content}>
      {backButton && backButton}
      <span className='bold-20'>Detalles de colaboradores</span>
      <FieldBold
        className={classes.field}
        title={`${collaborators.length} colaboradores`}
        value={`TOTAL COLABORADORES ${utils.moneyFormat(totalValueCollaborators)}`}
      />
      <div className={classes.cards}>
        {collaborators.map((collaborator, idx) => (
          <CardCollaboratorResume
            key={idx}
            view={view}
            downloadHandler={downloadHandler}
            collaborator={{
              statusDescription: collaborator.statusDescription,

              meloStatus: collaborator.meloStatus,
              receiverName: collaborator.receiverName,
              receiverLastName: collaborator.receiverLastName,
              metadata: collaborator.metadata,
              salaryToPay: collaborator.payedValue,
              receiverIdentificationType: collaborator.receiverIdentificationType,
              receiverIdentificationNumber: collaborator.receiverIdentificationNumber,
              salaryValue: collaborator.metadata.salaryValue,

              bankId: collaborator.bankId,
              bankAccountType: collaborator.bankAccountType,
              bankAccountNumber: collaborator.bankAccountNumber,
              bankAccountOwnerIdentificationType: collaborator.bankAccountOwnerIdentificationType,
              bankAccountOwnerIdentificationNumber: collaborator.bankAccountOwnerIdentificationNumber,
              name:
                collaborator.bankAccountOwnerPersonTypeId === '2'
                  ? `${collaborator.bankAccountOwnerName} ${collaborator.bankAccountOwnerLastName}`
                  : collaborator.bankAccountOwnerBusinessName
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default DetailsCollaborators;
